import type * as lazyIndex from './lazyIndex';
import {
    createLazyComponent,
    type LazyComponent,
    LazyModule,
    registerLazyOrchestrator,
} from 'owa-bundling';
import { openOneNoteFeedPanel } from 'owa-notes-feed-bootstrap';
import type { NotesPaneProps } from './components/NotesPane';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaNotes" */ './lazyIndex'),
    {
        name: 'OwaNotes',
    }
);

// Lazy orchestrator
registerLazyOrchestrator(openOneNoteFeedPanel, lazyModule, m => m.openOneNoteFeedPanelOrchestrator);

// Delay loaded components
export const NotesPane: LazyComponent<NotesPaneProps, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.NotesPane
);
